import React from 'react';
import './Blog.css';

const Blog = () => {
    return (
        <div id='blog'>
            <h2 className="blogs">The blog is coming soon...</h2>
        </div >
    );
};

export default Blog;